import { bunja } from 'bunja';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { PathnameScope, RouterScope } from '@flipster/react/providers/route';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { removeLocalePathname } from '@flipster/utils/pathname';
import { SessionStorageKey, getSessionStorage, setSessionStorage } from '@flipster/utils/sessionStorage';

const SignInPath = [
  '/signin',
  '/login',
  '/signup',
  '/email-signup',
  '/social-signup',
  '/forgotPassword',
  '/resetPassword',
  '/select-nationality',
];
const RequiredLoggedInPath = [
  '/ab-test',
  '/assets',
  '/user',
  '/history',
  '/support/referral',
  '/support/affiliate',
  '/oauth',
  '/vip/expected-benefits',
  '/pnl-analysis',
  '/support/proof-of-reserves/audit',
];
const ExcludeReferrerPath = [...SignInPath, '/maintenance', '/auth', '/404'];
const RequiredKolPath = '/support/affiliate';
const BlockKolPath = '/support/referral';

export const authRedirectBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const pathname = bunja.use(PathnameScope);
  const router = bunja.use(RouterScope);
  const { isCookieLoggedInAtom, isKolAtom, waitLoading } = bunja.use(authBunja);

  const withoutLocalePathname = removeLocalePathname(pathname);

  function setReferrerPath(): void {
    if (ExcludeReferrerPath.some((p) => withoutLocalePathname.startsWith(p))) return;
    // pathname에는 query string, hash가 포함되어 있지 않으므로 window.location.href를 사용
    setSessionStorage(SessionStorageKey.ReferrerPath, window.location.href.replace(window.location.origin, ''));
  }

  function gotoLoginPage(): void {
    const isCookieLoggedIn = store.get(isCookieLoggedInAtom);
    if (isCookieLoggedIn) return;
    if (
      RequiredLoggedInPath.some((path) => {
        const regex = new RegExp(`^${path}($|/)`);
        return regex.test(withoutLocalePathname);
      })
    ) {
      router.replace('/login');
    }
  }

  function gotoAfterLoginPage(): void {
    const isCookieLoggedIn = store.get(isCookieLoggedInAtom);
    if (!isCookieLoggedIn) return;
    if (SignInPath.some((path) => withoutLocalePathname.startsWith(path))) {
      const referrerPath = removeLocalePathname(getSessionStorage(SessionStorageKey.ReferrerPath) || '/');
      const shouldGotoAssets = referrerPath === '/';
      router.replace(shouldGotoAssets ? '/assets' : referrerPath);
    }
  }

  async function gotoReferralPage(): Promise<void> {
    await waitLoading();
    const isKol = store.get(isKolAtom);
    if (isKol) return;
    if (withoutLocalePathname.startsWith(RequiredKolPath)) {
      router.replace('/support/referral');
    }
  }

  async function gotoAffiliatePage(): Promise<void> {
    await waitLoading();
    const isKol = store.get(isKolAtom);
    if (!isKol) return;
    if (withoutLocalePathname.startsWith(BlockKolPath)) {
      router.replace('/support/affiliate');
    }
  }

  return {
    setReferrerPath,
    gotoLoginPage,
    gotoAfterLoginPage,
    gotoReferralPage,
    gotoAffiliatePage,
  };
});
